import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-[#0B1A2E] border-t border-[#1A2F4A] py-12 px-4" data-id="element-44">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-8 text-sm" data-id="element-45">
        {/* Left: Branding & Copyright */}
        <div className="text-center md:text-left text-[#94A3B8]" data-id="element-46">
          <p className="font-semibold text-[#F1F5F9] mb-2" data-id="element-47">
            ADHD Executive Function Toolkit
          </p>
          <p data-id="element-48">&copy; {new Date().getFullYear()} All rights reserved.</p>
        </div>

        {/* Center: Legal Links */}
        <div className="flex flex-col items-center gap-3" data-id="element-49">
          <Link to="/privacy" className="text-[#2DD4BF] hover:text-[#14B8A6] hover:underline transition-colors" data-id="element-50">
            Privacy Policy
          </Link>
          <Link to="/terms" className="text-[#2DD4BF] hover:text-[#14B8A6] hover:underline transition-colors" data-id="element-51">
            Terms of Service
          </Link>
        </div>

        {/* Right: Contact Info */}
        <div className="text-center md:text-right" data-id="element-52">
          <h4 className="text-xs font-bold tracking-wider uppercase text-[#64748B] mb-2" data-id="element-53">
            Contact Us
          </h4>
          <a href="mailto:support@adhdtoolkit.com" className="text-[#2DD4BF] hover:text-[#14B8A6] hover:underline transition-colors" data-id="element-54">
            support@adhdtoolkit.com
          </a>
        </div>
      </div>
    </footer>;
}